import { useState, Fragment, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Fab from "@mui/material/Fab";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { themeStyle } from "../../components/Components";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CardActionArea from "@mui/material/CardActionArea";
import Checkbox from "@mui/material/Checkbox";

function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function Shuffle() {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const state = useSelector((state) => state);

  const [isLoading, setIsLoading] = useState(true);

  const [classsPromotePageFrom, setClassPromotePageFrom] = useState("");
  const [divisionPromotePageFrom, setDivisionPromotePageFrom] = useState("");
  const [semesterPromotePageFrom, setSemesterPromotePageFrom] = useState("");
  const [classList, setClassList] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [random, setRandom] = useState("");
  const [info, setInfo] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [classsPromotePageTo, setClassPromotePageTo] = useState("");
  const [divisionPromotePageTo, setDivisionPromotePageTo] = useState("");
  const [semesterPromotePageTo, setSemesterPromotePageTo] = useState("");
  const [isReady, setIsReady] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);
  const [open6, setOpen6] = useState(false);
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [promoteSubmitAnswer, setPromoteSubmitAnswer] = useState("NO");

  function addToPromotedStudentsList(value, index) {
    var tempPromotedStudentsList = Array.from(studentList);

    tempPromotedStudentsList[index]["promote"] = value;

    setStudentList(tempPromotedStudentsList);
    setRandom(Math.random());
  }

  function promoteSubmit(unfinalize) {
    setIsSubmitting(true);
    setOpen6(false);
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    var body = {};

    body["institution_id"] = state.auth.user.institution_id;
    body["class_id_next"] = classsPromotePageTo;
    body["division_next"] = divisionPromotePageTo;
    body["semester_next"] = semesterPromotePageTo;
    body["class_id_current"] = classsPromotePageFrom;
    body["division_current"] = divisionPromotePageFrom;
    body["semester_current"] = semesterPromotePageFrom;
    body["student_list"] = studentList;
    body["carry"] = promoteSubmitAnswer;
    body["unfinalize"] = unfinalize;

    body = JSON.stringify(body);
    axios
      .post(API_URL + "/promote_class_division_semester", body, config)
      .then((res) => {
        setIsSubmitting(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
        setOpen6(false);
        getData();
        createAlert(
          "SUCCESS",
          "Success.",
          "Selected students have been promoted."
        );
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/principal_settings_page_info", body, config)
      .then((res) => {
        setInfo(res.data);

        axios.post(API_URL + "/get_class_list", body, config).then((res) => {
          var classListTemp = res.data;
          setClassList(classListTemp);
          setClass(Object.keys(classListTemp)[0]);
          setDivision(
            Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
          );

          setClassPromotePageFrom(Object.keys(classListTemp)[0]);
          setDivisionPromotePageFrom(
            Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
          );

          setSemesterPromotePageFrom(
            Object.keys(
              classListTemp[Object.keys(classListTemp)[0]][
                Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
              ]
            )[0]
          );

          setClassPromotePageTo(Object.keys(classListTemp)[0]);
          setDivisionPromotePageTo(
            Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
          );
          setSemesterPromotePageTo(
            Object.keys(
              classListTemp[Object.keys(classListTemp)[0]][
                Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
              ]
            )[0]
          );

          getStudents(
            Object.keys(classListTemp)[0],
            Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0],
            Object.keys(
              classListTemp[Object.keys(classListTemp)[0]][
                Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
              ]
            )[0]
          );
        });
      });
  }

  function getStudents(cla, div, sem) {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["class_id"] = cla;
    body["division"] = div;
    body["current_semester"] = sem;
    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_students_list_class", body, config)
      .then((res) => {
        var tempStudentList = res.data;

        for (var i = 0; i < tempStudentList.length; i++) {
          tempStudentList[i]["promote"] = true;
        }

        setStudentList(tempStudentList);
        setRandom(makeid(4));
        setIsReady(true);
        setIsLoading(false);
      });
  }

  function getClassListPromotePageFrom() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionListPromotePageFrom() {
    var classes = Object.keys(classList[classsPromotePageFrom]).map(
      (division, index) => <MenuItem value={division}>{division}</MenuItem>
    );
    return classes;
  }

  function getSemesterListPromotePageFrom() {
    var semesters = Object.keys(
      classList[classsPromotePageFrom][divisionPromotePageFrom]
    ).map((semester, index) => (
      <MenuItem value={semester}>{semester}</MenuItem>
    ));
    return semesters;
  }

  function getClassListPromotePageTo() {
    var classes = Object.keys(classList).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));
    return classes;
  }

  function getDivisionListPromotePageTo() {
    var classes = Object.keys(classList[classsPromotePageTo]).map(
      (division, index) => <MenuItem value={division}>{division}</MenuItem>
    );
    return classes;
  }

  function getSemesterListPromotePageTo() {
    var semesters = Object.keys(
      classList[classsPromotePageTo][divisionPromotePageTo]
    ).map((semester, index) => (
      <MenuItem value={semester}>{semester}</MenuItem>
    ));
    return semesters;
  }

  function handleSemesterChangePromotePageFrom(e) {
    setSemesterPromotePageFrom(e.target.value);
    getStudents(classsPromotePageFrom, divisionPromotePageFrom, e.target.value);
  }

  function handleClassChangePromotePageFrom(e) {
    setClassPromotePageFrom(e.target.value);
    setIsLoading(true);
    getStudents(
      e.target.value,
      divisionPromotePageFrom,
      semesterPromotePageFrom
    );
  }

  function handleDivisionChangePromotePageFrom(e) {
    setDivisionPromotePageFrom(e.target.value);
    setIsLoading(true);
    getStudents(classsPromotePageFrom, e.target.value, semesterPromotePageFrom);
  }

  function handleSemesterChangePromotePageTo(e) {
    setSemesterPromotePageTo(e.target.value);
  }

  function handleClassChangePromotePageTo(e) {
    setClassPromotePageTo(e.target.value);
  }

  function handleDivisionChangePromotePageTo(e) {
    setDivisionPromotePageTo(e.target.value);
  }

  function getContent() {
    return (
      <Fragment>
        <Grid container spacing={5}>
          <Grid item md={2}>
            <div
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                color: themeStyle.primaryColor,
                marginBottom: "5px",
              }}
            >
              From Class
            </div>
            <hr />
            <br />
            <span
              style={{
                color: themeStyle.primaryColor,

                fontSize: "14px",
              }}
            >
              Current Class
            </span>
            <Select
              value={classsPromotePageFrom}
              onChange={(e) => handleClassChangePromotePageFrom(e)}
              style={{
                marginTop: "2px",
                height: "40px",
                marginBottom: "5px",
              }}
              fullWidth
              variant={"outlined"}
            >
              {getClassListPromotePageFrom()}
            </Select>
            {/* <span
              style={{
                color: themeStyle.primaryColor,

                fontSize: "14px",
              }}
            >
              Current Division
            </span>
            <Select
              value={divisionPromotePageFrom}
              onChange={(e) => handleDivisionChangePromotePageFrom(e)}
              style={{
                marginTop: "2px",
                height: "40px",
                marginBottom: "5px",
              }}
              fullWidth
              variant={"outlined"}
            >
              {getDivisionListPromotePageFrom()}
            </Select> */}
            <div style={{ marginTop: "15px" }} />
            {state.auth.classType == "SEMESTERS" ? (
              <span
                style={{
                  color: themeStyle.primaryColor,

                  fontSize: "14px",
                }}
              >
                Current Semester
              </span>
            ) : (
              ""
            )}
            {state.auth.classType == "SEMESTERS" ? (
              <Select
                value={semesterPromotePageFrom}
                onChange={(e) => handleSemesterChangePromotePageFrom(e)}
                style={{
                  marginTop: "2px",
                  height: "40px",
                  marginBottom: "5px",
                }}
                fullWidth
                variant={"outlined"}
              >
                {getSemesterListPromotePageFrom()}
              </Select>
            ) : (
              ""
            )}
          </Grid>
          <Grid item md={8}>
            <Grid
              container
              spacing={2}
              style={{
                backgroundColor: themeStyle.primaryColorLight,
                padding: "10px 20px 20px 0px",
                borderRadius: "25px",
                marginTop: "25px",
              }}
            >
              {studentList.map((student, index) => (
                <Grid item xs={4}>
                  <CardActionArea
                    sx={[
                      {
                        height: "100%",
                        borderRadius: "6px",
                        border: "1.5px solid " + themeStyle.primaryColorLight,
                        transition: "background-color 0.5s, border-color 0.5s",
                      },
                      (theme) => ({
                        "&:hover": {
                          backgroundColor: "#ebf5ff",
                          borderColor: themeStyle.primaryColor,
                        },
                        ".MuiCardActionArea-focusHighlight": {
                          background: "transparent",
                        },

                        "&& .MuiTouchRipple-child": {
                          backgroundColor: "#084594",
                        },
                      }),
                    ]}
                    style={{
                      padding: "10px",
                      borderRadius: "6px",
                      marginBottom: "5px",
                      border: "2px solid " + themeStyle.primaryColorLight,
                      backgroundColor: themeStyle.secondaryColor,
                      borderRadius: "6px",
                      cursor: "pointer",
                    }}
                    onClick={() => {}}
                  >
                    <Grid
                      container
                      justifyContent="space-between"
                      alignItems="flex-start"
                    >
                      <Grid item md={11}>
                        <b
                          style={{
                            fontSize: "20px",
                            color: "white",
                          }}
                        >
                          {student["name"]}
                        </b>
                        <br></br>
                        {/* <span
                          style={{
                            color: "#bbb",
                            fontSize: "16px",
                          }}
                        >
                          {" "}
                          Roll no
                          <span style={{}}>{" " + student["roll_number"]}</span>
                        </span> */}
                      </Grid>

                      <Grid item md={1}>
                        <Checkbox
                          checked={studentList[index]["promote"]}
                          onChange={(e) => {
                            addToPromotedStudentsList(e.target.checked, index);
                          }}
                          value={1}
                          style={{
                            marginTop: "-17px",
                            color: themeStyle.primaryColorLight,
                          }}
                        />
                      </Grid>
                    </Grid>
                  </CardActionArea>
                </Grid>
              ))}
            </Grid>
          </Grid>

          <Grid item md={2}>
            <div
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                color: themeStyle.primaryColor,
                marginBottom: "5px",
              }}
            >
              To Class
            </div>
            <hr />
            <br />
            <span
              style={{
                color: themeStyle.primaryColor,

                fontSize: "14px",
              }}
            >
              Pomote to Class
            </span>
            <Select
              value={classsPromotePageTo}
              onChange={(e) => handleClassChangePromotePageTo(e)}
              style={{
                marginTop: "2px",
                height: "40px",
                marginBottom: "5px",
              }}
              fullWidth
              variant={"outlined"}
            >
              {getClassListPromotePageTo()}
            </Select>
            {/* <span
              style={{
                color: themeStyle.primaryColor,

                fontSize: "14px",
              }}
            >
              Promote to Division
            </span>
            <Select
              value={divisionPromotePageTo}
              onChange={(e) => handleDivisionChangePromotePageTo(e)}
              style={{
                marginTop: "2px",
                height: "40px",
                marginBottom: "5px",
              }}
              fullWidth
              variant={"outlined"}
            >
              {getDivisionListPromotePageTo()}
            </Select> */}
            {state.auth.classType == "SEMESTERS" ? (
              <span
                style={{
                  color: themeStyle.primaryColor,

                  fontSize: "14px",
                }}
              >
                Promote to Semester
              </span>
            ) : (
              ""
            )}
            {state.auth.classType == "SEMESTERS" ? (
              <Select
                value={semesterPromotePageTo}
                onChange={(e) => handleSemesterChangePromotePageTo(e)}
                style={{
                  marginTop: "2px",
                  height: "40px",
                  marginBottom: "5px",
                }}
                fullWidth
                variant={"outlined"}
              >
                {getSemesterListPromotePageTo()}
              </Select>
            ) : (
              ""
            )}
          </Grid>
        </Grid>
      </Fragment>
    );
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (isLoading) {
        return (
          <Fragment>
            <Sidebar />
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                marginTop: "46vh",
              }}
            >
              <CircularProgress />
            </div>
          </Fragment>
        );
      } else {
        return (
          <Fragment>
            <Sidebar />
            <div
              style={{
                margin: "65px 15px 20px 85px",
                backgroundColor: "white",
              }}
            >
              {getContent()}
              {state.auth.finalized ? (
                <Button
                  fullWidth
                  onClick={() => setOpen3(true)}
                  p={2}
                  style={{
                    position: "fixed",
                    bottom: 30,
                    right: 30,
                    backgroundColor: themeStyle.primaryColor,
                    color: "white",
                    height: "30px",
                    width: "200px",
                  }}
                  borderRadius={6}
                >
                  <h3
                    style={{
                      marginTop: "17px",
                      fontSize: "15px",
                    }}
                  >
                    SHUFFLE STUDENTS
                  </h3>
                </Button>
              ) : (
                <Button
                  fullWidth
                  p={2}
                  style={{
                    position: "fixed",
                    bottom: 30,
                    right: 30,
                    backgroundColor: "grey",
                    color: "white",
                    height: "30px",
                    width: "400px",
                  }}
                  borderRadius={6}
                >
                  <h3
                    style={{
                      marginTop: "17px",
                      fontSize: "15px",
                    }}
                  >
                    CLASSES FINALIZATION REQUIRED
                  </h3>
                </Button>
              )}
            </div>
          </Fragment>
        );
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}
export default Shuffle;
